import { useQuery, UseQueryResult } from "react-query";

import { createUrl } from "../../utils/UrlUtils";
import { ApiRoutes } from "../../constants/ApiRoutes";
import { httpClient } from "../../api-legacy/BaseApi";
import { formatResponse } from "../../utils/FormatUtils";

export function useClinicalNoteAddendumNamesQuery(): UseQueryResult<any, Error> {
  return useQuery(["clinical-note", "addendum-names"], () =>
    httpClient.get(createUrl(ApiRoutes.clinicalNoteAddendumNames, {})).then(formatResponse),
  );
}
